import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { RegionDTO } from '../../../api/region-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveRegionModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedRegion?: RegionDTO;
    onHide: () => void;
    onSave: (values: RegionDTO) => void;
    onDelete?: (region: RegionDTO) => void;
}

export function SaveRegionModal({
    show,
    allowEdit,
    selectedRegion,
    onHide,
    onSave,
    onDelete,
}: SaveRegionModalProps) {
    const RegionSchema = yup.object().shape({
        id: yup.string().required(' '),
        name: yup.string().required(' '),
        description: yup.string().required(' '),
    });

    const defaultValues: RegionDTO = {
        id: selectedRegion ? selectedRegion.id : '',
        name: selectedRegion ? selectedRegion.name : '',
        description: selectedRegion ? selectedRegion.description : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={RegionSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedRegion ? 'edit-region' : 'new-region'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedRegion && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedRegion)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit || !!selectedRegion}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="name"
                                name="name"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                        <FormikTextField
                            type="textarea"
                            label="description"
                            name="description"
                            readOnly={!allowEdit}
                            className="w-100"
                            handleEnter
                        />
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
